const editProfileBtn = () => {
    const page = document.querySelector('.profile_page');
    if (!page) return;
    const form = page.querySelector('#profile_edit_form');
    const data = page.querySelector('.profile_data');
    const edit = page.querySelector('[data-profile-edit]');
    const photo = page.querySelector('[data-profile-photo]');
    const input = form.querySelector('[name="profile_image"]');
    const setEditing = (editing) => {
        page.dataset.editing = String(editing);
        form.hidden = !editing;
        data.hidden = editing;
        edit.setAttribute('aria-expanded', String(editing));
    };
    edit.addEventListener('click', () => {
        setEditing(true);
        form.querySelector('[name="first_name"]').focus();
    });
    photo.addEventListener('click', () => {
        setEditing(true);
        input.click();
    });
    input.addEventListener('change', () => {
        const hint = page.querySelector('.profile_upload_hint');
        hint.textContent = input.files.length
            ? `Foto seleccionada: ${input.files[0].name}. Guarda los cambios para aplicarla.`
            : 'Selecciona una imagen para actualizar tu foto.';
        if (input.files.length) {
            const clear = form.querySelector('[name="profile_image-clear"]');
            if (clear) clear.checked = false;
        }
    });
    page.querySelector('[data-profile-cancel]').addEventListener(
        'click',
        () => {
            form.reset();
            page.querySelector('.profile_upload_hint').textContent =
                'Selecciona una imagen para actualizar tu foto.';
            setEditing(false);
            edit.focus();
        },
    );
    const updateName = () => {
        form.querySelector('[name="name"]').value =
            `${form.querySelector('[name="first_name"]').value.trim()} ${form.querySelector('[name="last_name"]').value.trim()}`.trim();
    };
    form.querySelector('[name="first_name"]').addEventListener(
        'input',
        updateName,
    );
    form.querySelector('[name="last_name"]').addEventListener(
        'input',
        updateName,
    );
    form.addEventListener('submit', updateName);
};
export default editProfileBtn;
